module.exports = __webpack_public_path__ + "img/LandingPage_Shopfloor.0f798bf2.jpg";